
<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-0">IT Facility Closer</h4>
        
      </div>
      <button class="btn btn-secondary btn-sm" (click)="back()">Back</button>
    </div>
    <div class="card-body">
      <form>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Employee ID</label>
         <!--<select class="form-select" [(ngModel)]="ITcloserData.employeeid" name="employeeId" (change)="Onselectempolyee()">
            <option value="">Select Employee</option>
            <option *ngFor="let emp of employeeId" [value]="emp.IR_EmployeeId">{{ emp.IR_EmployeeId }}</option>
          </select> -->
        
          <input class="form-control" [(ngModel)]="ITcloserData.employeeid" name="employeeid" />
        
        </div>
        
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Full Name</label>
          <input class="form-control" [(ngModel)]="ITcloserData.Fullname" name="lastName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">AD User Name</label>
          <input class="form-control" [(ngModel)]="ITcloserData.Username" name="designation" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Mail ID</label>
          <input class="form-control" [(ngModel)]="ITcloserData.Mailid" name="grade" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Designation</label>
          <input class="form-control" [(ngModel)]="ITcloserData.Designation" name="dateOfJoining" type="text" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">location</label>
          <input class="form-control" [(ngModel)]="ITcloserData.grade" name="plant" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Department</label>
          <input class="form-control" [(ngModel)]="ITcloserData.department" name="department" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Assert Type</label>
          <input class="form-control" [(ngModel)]="ITcloserData.AssertType" name="AssertType" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">NAS Drive Access</label>
          <input class="form-control" [(ngModel)]="ITcloserData.DriveAccess" name="DriveAccess" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Dongle & Sim Card</label>
          <input class="form-control" [(ngModel)]="ITcloserData.Dongle" name="Dongle" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Mobile & Sim Card</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MSimcard" name="MSimcard" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">BioMetric Access Card</label>
          <input class="form-control" [(ngModel)]="ITcloserData.Biometric" name="Biometric" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Door Access</label>
          <input class="form-control" [(ngModel)]="ITcloserData.DoorAccess" name="DoorAccess" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Other</label>
          <input class="form-control" [(ngModel)]="ITcloserData.Other" name="Other" /><!--*ngIf="appservice.editchecker==='rejected'"-->
        </div>
        <div class="mb-3 d-flex align-items-center" >
  <label class="form-label me-3" style="width: 150px;">Comments</label>
  <textarea
  class="form-control"
  [(ngModel)]="ITcloserData.command"
  name="command"
  style="height: 50px;"
  placeholder="Reason">
</textarea>

</div>

        <div class="action-buttons d-flex justify-content-start gap-2 mt-3">
          <button class="btn btn-approve" type="button" (click)="onApprove()">Approve</button><!-- " (click)="onApprove()(click)="onDecline()*ngIf="appservice.checkereditdata.status === 'Approved' *ngIf="appservice.checkereditdata.status === 'Rejected'-->
          <button class="btn btn-decline" type="button" (click)="onDecline()">Decline</button>
        </div>
      </form>
    </div>
  </div>
</div>
